import { useMutation, useQueryClient } from "@tanstack/react-query";

import { NECESSARY_INFO_LACKING_HINT } from "@/shared";
import { updateDevice } from "@/shared/requests/device";
import { getStorage } from "@/shared/store";

import { NecessaryInfoLackingError } from "./errors.type";
import { DEVICE_QUERY_KEY } from "./queryKey";

export const useDeleteIMEI = () => {
  const queryClient = useQueryClient();
  const mutationFn = async () => {
    const device_id = getStorage("deviceId");
    // console.log("device_id",device_id)
    const imei = getStorage("imei");
    // const imei = "1234567890";
    // const sn = getStorage("serialNumber");
    // console.log("imei",imei)
    // console.log("sn",sn)
    if (!device_id || imei === undefined)
      throw new NecessaryInfoLackingError(NECESSARY_INFO_LACKING_HINT);
    return updateDevice({ device_id, imei });
  };

  return useMutation(mutationFn, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [DEVICE_QUERY_KEY] });
    },
  });
};
